var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacetedMarquise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "dia-faceted-marquise",
    viewBox: "19 16 54 54",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    id: "bg-fill_24_",
    d: "M46.4 16.2c-.2-.1-.5-.1-.7 0-.1.1-14.7 7.8-14.7 26.4C30.9 61.2 45.5 69 45.7 69c.1.1.2.1.4.1.1 0 .2 0 .4-.1.1-.1 14.7-7.8 14.7-26.4-.1-18.6-14.7-26.3-14.8-26.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "shadow_24_",
    fill: "currentColor",
    fillOpacity: 0.085,
    d: "M39.6 42.6c0-11.6 4.2-22.8 5.5-26-2.8 1.7-14.1 9.7-14.1 26 0 16.5 11.5 24.5 14.2 26.1-1.3-2.9-5.6-14.2-5.6-26.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "stroke_23_",
    fill: "currentColor",
    d: "M46.4 16.2c-.2-.1-.5-.1-.7 0-.1.1-14.7 7.8-14.7 26.4C30.9 61.2 45.5 69 45.7 69c.1.1.2.1.4.1.1 0 .2 0 .4-.1.1-.1 14.7-7.8 14.7-26.4-.1-18.6-14.7-26.3-14.8-26.4zm9 41.6L49.8 62l3-9.2.4-.7 3.5-2.9-.5 7c-.1.6-.4 1.1-.8 1.6zM46 67.5c-.1-.1-.3-.2-.4-.3l-2.7-4.6 3-2.9h.2l3 2.9-2.7 4.6c-.1.1-.3.2-.4.3zm-9.4-40.1l5.6-4.2-3 9.2-.4.7-3.5 2.9.5-7c.2-.5.5-1.1.8-1.6zm9.4-9.6c.1.1.3.2.4.3l2.7 4.6-3 2.9h-.2l-3-2.9 2.7-4.6c.2-.1.3-.2.4-.3zM32.5 42.6v-1l2.4-4.5 1.5 5.1v.8l-1.5 5.1-2.4-4.5v-1zM52.4 52L46 58.7 39.6 52l-2.4-9.3 2.4-9.3 6.4-6.7 6.4 6.7 2.4 9.3-2.4 9.3zm1.1-18.1l3.4 2.7-1.4 4.8-2-7.5zm-7-8.1l2.8-2.7 2.9 8.7-5.7-6zm-6.6 5.9l2.9-8.7 2.8 2.7-5.7 6zm-3.3 9.7l-1.4-4.8 3.4-2.7-2 7.5zm0 2.5l1.9 7.5-3.4-2.7 1.5-4.8zm8.9 15.6l-2.8 2.7-2.9-8.7 5.7 6zm6.7-6l-2.9 8.7-2.8-2.7 5.7-6zm3.2-9.6l1.4 4.8-3.4 2.7 2-7.5zm1.8 4.2L55.7 43v-.8l1.5-5.1 2.3 4.5v2l-2.3 4.5zm.1-11.6l-.5-6.4c1.3 2.9 2.3 6.4 2.6 10.5l-2.1-4.1zm-.9-7.5l.5 7-3.5-2.9-.4-.7-3-9.2 5.6 4.2c.2.5.5 1.1.8 1.6zm-21.7 7.5l-2.1 4.1c.3-4.1 1.2-7.5 2.6-10.5l-.5 6.4zm0 12.3l.5 6.4c-1.4-2.9-2.3-6.4-2.6-10.5l2.1 4.1zm1 7.4l-.5-7 3.5 2.9.4.7 3 9.2-5.6-4.2c-.2-.5-.5-1-.8-1.6zm21.6-7.4l2.1-4.1c-.3 4.1-1.2 7.5-2.6 10.5l.5-6.4zm-2.5-22.4l-5.2-3.9-2.3-3.9c1.8 1.3 4.9 3.8 7.5 7.8zm-10-7.8l-2.3 3.9-5.2 3.9c2.5-4 5.6-6.5 7.5-7.8zm-7.6 40.3l5.2 3.9 2.3 3.9c-1.8-1.3-4.9-3.9-7.5-7.8zm10.1 7.8l2.3-3.9 5.2-3.9c-2.6 3.9-5.7 6.5-7.5 7.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetedMarquise);
export default __webpack_public_path__ + "static/media/faceted-marquise.ef33732b017c7f06eb9fe8f3c074dc77.svg";
export { ForwardRef as ReactComponent };